<template>
  <!-- <div v-if="store_closed">
    <div class="store_closed">
      <h1>This store is Currently Closed</h1>
      <button class="btn section-back-btn mt-2" @click="$router.go(-1)">Go Back</button>
    </div>
  </div> -->
    <div class="shimmerContainer" v-if="loader == true">
       <PuSkeleton class=" Skeletonitem1" height="inherit" style="padding:0 ; " />
       <PuSkeleton class=" Skeletonitem2" height="inherit" style="padding:0 ; " />
       <PuSkeleton class=" Skeletonitem3" height="inherit" style="padding:0 ; " />
       <PuSkeleton class=" Skeletonitem4" height="inherit" style="padding:0 ; " />

       
       <!-- <PuSkeleton class=" Skeletonitem1" height="10vh" style="padding:0 ; " /> -->
        
  </div>
<div v-else>

  <div v-if="errorMsg">
    <div class="store_closed">
      <!-- <h1>This store is Currently Closed</h1> -->
      <!-- <img src="/img/wndw_coming_soon.png" class="img-fluid"> -->
      <h2>{{this.errorMsg}}</h2>
      
      
      <button class="btn storeBackBtn" @click="$router.go(-1)">Go Back</button>
    </div>
  </div>
  <div v-else>
    <div class="container-fluid p-0">
      
      <Slider :data="slides"/>
    </div>
    <div class="container-fluid">
      <div class="mx-2">
        <div class="row storeLandingNav">
          <div class="col-md-2 col-5">
            <img :src="logo" class="img-fluid storeLogo" alt="" />
            <div class="storeFrontLocation forMobile">
              <p class="storeFrontLocationText mb-0" @click="storeFrontLocation"> {{storeLocation}} 
              <i class="fa fa-angle-down" v-if="popUpStores.length>0"></i> </p>
            </div>
            
            <!-- <img
									:src="policies[0].image"
									class="img-fluid storeLogo"
									alt=""
								/> -->
          </div>
          <div class="col-md-10 col-7 text-center burger-tab">
             <!-- <div
          class="call policyTab  mobile-display"
          v-if="this.policies[0].phone_number"
        >
          <div class="number">
            <a :href="'tel:' + this.policies[0].phone_number">
             
            </a>
          </div>
         

        </div> -->
          
          <div class="forMobile storeMobileMenu-one" :class="{ showStoreSearch : storeSearchToggle}"> 
            <span class="storeIcon" @click="isStoreSearch = true"></span> 
                <!-- <span class="storeIconClose" @click="storeSearchIcon()">X</span>  -->
          </div>
          <div class="call policyTab whats-phone mobile-display">
            <a target="blank" :href="`https://api.whatsapp.com/send?phone=${encodeURI(`+91${this.policies[0].whatsapp_number}`)}`"><i class="fa fa-whatsapp" style="color: #075e54" aria-hidden="true"></i></a>
          </div>
            <a class="forMobile storeMobileMenu" @click="toggleMenu()" href="javascript:void(0)" >
              
              <div class="burger"><span></span><span></span><span></span></div>
            </a>
            
            <ul class="storeLandingNavLinks forDesktop" >
           
              <li v-for="(link, i) in refinedMenu" :key="i">
                <router-link
                  :to="{
                    name: 'list',
                    query: {
                      store: $route.query.store,
                      category: link.id_category,
                        name:link.cat_name,
                        isFromStore:true
                    },
                    params: {
                      menu_url_key: `store-${$route.query.store}`
                    }
                  }"
                >
                  {{ link.name }}
                </router-link>
              </li>
             
               <li >
                <router-link
                  :to="{
                    name: 'list',
                    query: {
                      store: $route.query.store,
                      category: 11650,
                        name:'All Products',
                         isFromStore:true
                    },
                     params: {
                      menu_url_key: `store-${$route.query.store}`
                    }
                  }"
                >
                 All Products
                </router-link>
              </li>
              <li :class="{ showStoreSearch : storeSearchToggle}"> 
                
                <span class="storeIcon" @click="isStoreSearch = true"></span> 
                <!-- <span class="storeIconClose" @click="storeSearchIcon()">X</span>  -->
                
              </li>
               <li v-if="this.inner_menu" @click="isMenu = true">
               <i class="fa fa-bars"></i> More
              </li>
            </ul>
            <ul class="storeLandingNavLinks forMobile mobileStoreToggle" v-if="isMenu">
           
             <li
          class="policyTab"
          :class="{ active: id == i }"
          @click="policyContent(null)"
      >
          Store Front
        </li>

        <li
          class="policyTab"
          :class="{ active: id == i }"
          @click="policyContent(i)"
          v-for="(item, i) in policies"
          :key="i"
        >
          {{ item.name }}
        </li>
              
               
            </ul>
            
          </div>
        </div>
      </div>
    </div>
   
    
    <div class="policies">
      <div class="policyTabs storeMenu">
        <div class="storeFrontLocation forDesktop">
          <p class="storeFrontLocationText mb-0" @click="storeFrontLocation"> {{storeLocation}} 
            <i class="fa fa-angle-down" v-if="popUpStores.length>0"></i> </p>
        </div>
        <div
          class="policyTab mobile-display"
          :class="{ active: id == null }"
          @click="policyContent(null)"
        >
          Store Front
        </div>

        <div
          class="policyTab mobile-display"
          :class="{ active: id == i }"
          @click="policyContent(i)"
          v-for="(item, i) in policies"
          :key="i"
        >
          {{ item.name }}
        </div>
        <div
          class="policyTab policy-menu">
        
                <router-link
                  :to="{
                    name: 'list',
                    query: {
                      store: $route.query.store,
                      category: 11650,
                       isFromStore:true
                    },
                     params: {
                      menu_url_key: `store-${$route.query.store}`
                    }
                  }"
                >
                 All Products
                </router-link>
              
        </div>
        <div
          class="policyTab policy-menu"
         v-for="(link, i) in inner_menu" :key="i">
                <router-link
                  :to="{
                    name: 'list',
                    query: {
                      store: $route.query.store,
                      category: link.id_category,
                       isFromStore:true
                    },
                     params: {
                     menu_url_key: `store-${$route.query.store}`
                    }
                  }"
                >
                  {{ link.name }}
                </router-link>
              
        </div>

         <div
          class="call policyTab desktop-mobile"
          v-if="this.policies[0].phone_number"
        >
          <div class="number">
            <a :href="'tel:' + this.policies[0].phone_number">
            </a>
          </div>
         
        </div>
        <div class="call policyTab desktop-mobile"
        v-if="this.policies[0].whatsapp_number">
          <div>
              <a target="blank" :href="`https://api.whatsapp.com/send?phone=${encodeURI(`+91${this.policies[0].whatsapp_number}`)}`"><i class="fa fa-whatsapp" style="color: #075e54" aria-hidden="true"></i></a>
          </div>
        </div>
       
       
      </div>
      <!-- main page  start-->
      <div class="storeFront" v-if="this.id == null">
        <div v-for="(sections, i) in storeTemplate" :key="i">
      
          <div class="storeSection"
            :class="{
              'container-fluid': sections.width == 'full',
              container: sections.width == 'boxed',
            }"
            v-if="
             sections.arrangement =='oneByOne' && i !='slider'
            "
          >
            <h1
              class="text-center miniStoreHeading"
              v-if="sections.header_title"
            >
              {{ sections.header_title !='null' ? sections.header_title : '' }}
            </h1>

            <Banner :data="sections.banners" />
          </div>

          <div class="storeSection"
            :class="{
              'container-fluid': sections.width == 'full',
              container: sections.width == 'boxed',
            }"
            v-else-if="
              sections.arrangement =='oneByTwo' 
            "
          >
            <h1
              class="text-center miniStoreHeading"
              v-if="sections.header_title"
            >
              {{ sections.header_title !='null' ? sections.header_title :'' }}
            </h1>

            <OneByTwo :id="themeId" :data="sections.banners" />
          </div>
          <div class="storeSection"
            :class="{
              'container-fluid': sections.width == 'full',
              container: sections.width == 'boxed',
            }"
            v-else-if="
             sections.arrangement =='oneByThree'
            "
          >
            <h1
              class="text-center miniStoreHeading"
              v-if="sections.header_title"
            >
              {{ sections.header_title !='null' ? sections.header_title :'' }}
            </h1>
            <OneByThree
              v-if="$root.window.width > 767"
              :data="sections.banners"
               :id="themeId"
            />
           
            <SliderOneByThree v-else-if="sections.arrangement =='oneByThree'" :data="sections.banners" />
             <OneByThree v-else
            
              :data="sections.banners"
            />
          </div>

          <div class="storeSection"
            :class="{
              'container-fluid': sections.width == 'full',
              container: sections.width == 'boxed',
            }"
            v-else-if="(sections.type = 'product_listing_two'&&sections.products.length>0)"
          >
        
         
            <h1
              class="text-center miniStoreHeading"
              v-if="sections.header_title"
            >
              {{ sections.header_title !='null' ? sections.header_title :'' }} 
            </h1>
            <ProductsGrid :data="sections.products" />
          </div>
          <div class="storeSection"
            :class="{
              'container-fluid': sections.width == 'full',
              container: sections.width == 'boxed',
            }"
            v-else-if="(sections.type = 'product_listing_one' && sections.products.length>0)"
          >
        
         
            <h1
              class="text-center miniStoreHeading"
              v-if="sections.header_title"
            >
              {{ sections.header_title !='null' ? sections.header_title :'' }}
            </h1>
            <ProductsGrid :data="sections.products" />
          </div>

          <!-- <div
            :class="{
              'container-fluid': sections.width == 'full',
              container: sections.width == 'boxed',
            }"
            v-else-if="sections.type == 'video'"
          >
            <Video :data="sections.video_link" />
          </div> -->
        </div>
      </div>
      <!-- main page end -->
      <div class="policyContent  info_lefts" v-if="(id!=null &&  Object.keys(store_address).length !== 0 )" >
         <div class="row"> 
                <div class="col-lg-8 col-md-8 col-12">
                    <h3 class="store-name">{{store_address.store_name}}</h3>
                    <div class="d-flex w-100">
                      <div class="w-50">
                        <span class="label font-medium"><strong> Email Id </strong></span> <br>
                        <span class="" ><span>{{store_address.store_email}} </span></span> 
                      </div>
                      <div class="w-50">
                        <span class="label font-medium"><strong>Landline Number </strong></span> <br>
                        <span class="" ><span>{{store_address.store_landline_number}} </span></span>
                      </div>
                    </div>
                    <div class="d-flex w-100 mt-2">
                      <div class="w-100">
                         <span class="label font-medium"><strong> Address  </strong></span> <br>
                        <span class="" ><span>{{store_address.address_primary}} </span></span> 
                      </div>
                      <div class="w-100" v-if="store_address.address_secondary != null">
                        <span class="label font-medium"><strong> Second Address </strong></span>
                        <span class="" ><span>{{store_address.address_secondary}} </span></span>
                      </div>
                    </div>
                    <div class="d-flex w-100 mt-2">
                      <div class="w-25">
                       <span class="label font-medium"><strong> City</strong></span> <br>
                        <span class="" ><span> {{store_address.city}} </span></span>
                      </div>
                      <div class="w-25">
                         <span class="label font-medium"><strong> Pin code</strong></span> <br>
                        <span class="" ><span> {{store_address.pincode}} </span></span>
                      </div>
                      <div class="w-25">
                         <span class="label font-medium"><strong> State</strong></span> <br>
                        <span class="" ><span> {{store_address.state}}</span></span>
                      </div>
                    </div>
              

                </div>
                <div class="col-lg-4 col-md-4 col-12">
                  <div class="address-map">
                      <GmapMap
                        id="map"
                        :center="center"
                        :zoom="15"
                        :options="{
                          zoomControl: true,
                          mapTypeControl: false,
                          scaleControl: false,
                          streetViewControl: false,
                          rotateControl: false,
                          fullscreenControl: false,
                          disableDefaultUi: false,
                          componentRestrictions: {
                            country: ['in'],
                          },
                        }"
                        map-type-id="terrain"
                        style="width: 100%; height: 300px"
                       
                      >
                        <GmapMarker
                          v-for="(marker, i) in markers"
                          :position="marker.position"
                          :clickable="true"
                          :draggable="false"
                          :key="i"
                        />
                      </GmapMap>
                  </div>
                </div>
          </div>
      </div>
      <div class="policyContent" v-if="id!=null" v-html="content">
         
      </div>
      <div class="rightFilterWrap forDesktop" :class="{ showFilter: isMenu }">
        <div class="overFlow" @click="isMenu = false"></div>
        <div class="rightFiterContent storeRightFilterWrap">
          <div class="filterHeading">
            <p
              class="float-left mr-3 text-dark cursorPointer"
              @click="isMenu = false"
            >
              &#10005;
            </p>
            Back to store 
          </div>
          <div class="filterData">
            <div class="storeRightFilter">
              <div id="accordion" class="accordion-container">
                <li class="sotreBorder" v-for="(link, i) in inner_menu" :key="i">
                <router-link
                  :to="{
                    name: 'list',
                    query: {
                      store: $route.query.store,
                      category: link.id_category,
                        name:link.cat_name,
                        isFromStore:true
                    },
                    params: {
                      menu_url_key: `store-${$route.query.store}`
                    }
                  }"
                >
                  {{ link.name }}
                </router-link>
              </li>
               <!-- <li>
                <router-link
                  :to="{
                    name: 'list',
                    query: {
                      store: $route.query.store,
                      category: 11650,
                        name:'All Products',
                         isFromStore:true
                    },
                     params: {
                      menu_url_key: `store-${$route.query.store}`
                    }
                  }"
                >
                 All Products
                </router-link>
              </li> -->
              
              </div>
            </div>
            
          </div>
        </div>
      </div>
      <div class="rightFilterWrap " :class="{ showFilter: isStoreSearch }">
        <div class="overFlow" @click="closeStoreSearch"></div>
        <div class="rightFiterContent storeRightFilterWrap">
          <div class="filterHeading">
          
            <p class="float-left mr-3 text-dark cursorPointer"
              @click="closeStoreSearch" >
              &#10005;
            </p>
            Store Search
          </div>
          <div class="filterData">
            <div class="storeRightFilter">
                        <div
                          class="input activeSearch newAtiveSearch"
                          :class="{ removeicon: removesearchicon}"
                          
                          style="width:100%"
                        >
                              <input
                              type="text"
                              @keyup.enter="enterFirstLink"
                              @keyup.esc="closeSearch"
                              class="field searchInputField"
                              placeholder="Search"
                              id="searchval"
                              @input="debouncesearch()"
                              />
                            <div v-if="searchloader" class="newspinner"> <i class="fa fa-spinner fa-spin"></i> </div>
                            <div v-if="searchclose" @click="closeSearch" class="crossIcons newcrossicon">X</div>
                        </div>
                        
                        <div v-if="searchres" class="newsearch">

                          <div v-if="noresult" class="newSearchNotch">
                            <div class="resultnotfound"> No result found </div>
                          </div>
                          <div v-if="searchingres" class="newSearchNotch">
                            <div class="resultnotfound"> Searching in wndw </div>
                          </div>
                          <div v-if="searchresult" class="newSearchNotch" style="padding: 12px 12px;">
                            <p class="mb-0 matchcategory">Matching Categories</p>
                                <router-link
                                  class="categoryLink mt-2"
                                  style="display:block;margin:13px 2px"
                                  @click.native="categoryProducts"
                                  :to="{
                                                      name: 'list',
                                                      query: {
                                                      store: $route.query.store,
                                                      category: category.id,
                                                          name:category.name,
                                                          isFromStore:true,
                                                          sq:search,
                                                          url_key: category.url_key
                                                      },
                                                      params: {
                                                      menu_url_key: `store-${$route.query.store}`
                                                      }
                                                  }"

                                  v-for="(category, i) in categories"
                                  :key="`${category.id_category}-${i}`"
                                  ><b class="search-text">{{ search }}</b> <span class="search-in"> in </span>  <span><b>{{ category.name }}</b></span></router-link
                                >
                          </div>
                            
                        </div>
                        <!-- <search class="storeSearch"  />  -->
            </div>
            
          </div>
        </div>
      </div>
    </div>
<!-- v-if="this.popUpStores.length != '0' " -->
    <div id="coupon-modal" class="modal"  :class="{active : isStoreLocation === true &  popUpStores.length>0}" >
      <div class="modal-dialog listStorePopup">
        <div class="modal-content">
          <div class="modal-body">
            <button type="button" @click="isStoreLocation = false" class="close" style="margin-top: 0px; margin-right: 15px; z-index: 999; top: 15px; right: 0px; font-size: 25px;">×</button>
            <div>
              <div class="storePopupHeading">
                <h3>{{storeName}}</h3>
                <!--  -->
                <small> {{popUpStores&&popUpStores.length}} Stores near you</small>
              </div>
              <div class="storeWrap">
                <div class="row storePopupDetail">
                  <div class="col-7">
                    <strong>Address</strong>
                  </div>
                  <div class="col-2">
                    <strong>Rating</strong>
                  </div>
                  <div class="col-3">
                    <strong>Distance</strong>
                  </div>
                </div>
                <div class="row storePopupData" v-for="(store, i) in popUpStores" :key="i">
                  <a :href="'/store.html'+'?store='+`${store.id}`" class="col-7 popuplink">
                    <div style="display: flex; justify-content: space-between;"> {{store.location_name}}  
                    </div>
                  </a>
                  <div class="col-2">
                    <i class="fa fa-star"></i> {{store.ratings.avg_rating}}
                  </div>
                  <div class="col-3">{{store.distance}} km</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  </div>

  
</template>
<style>
.categoryLink{
      font-size: 14px !important;
}
.newSearchNotch{
  overflow-y: auto;
    /* display: flex; */
    /* flex-direction: row-reverse; */
    max-height: 400px;
    border: 1px solid #d4d4d4;
    margin-top: 10px;
    background-color: #fff;
}
.resultnotfound{
      /* border-left: 1px solid rgb(235, 236, 240); */
    padding: 1rem;
    width: 100%;
}

.newsearch{
  position: absolute;
  top:40px;
  height: auto;
  width: 100%;
  padding: 4px;
  margin: 0px;
  background-color: transparent;
}
.newsearch::before{
  position: absolute;
		content: "";
		width: 10px;
		height: 10px;
		background: white;
		left: 30px;
		top: 9px;
		transform: rotate(45deg);
		border-top: 1px solid #d4d4d4;
		border-left: 1px solid #d4d4d4;
}
.removeicon::before{
  display: none;
}
.newspinner{
  position: absolute;
    top: 2px !important;
    font-size: 18px !important;
    right: 40px !important;
}
.newcrossicon{
  right: 17px !important;
  font-size: 19px !important;
  top: 4px !important;
}
@media screen and (max-width: 767px) {
  /* .resultnotfound{
    border: 1px solid #d4d4d4;
  } */
  .newspinner{
  top: 5px !important;
}
.newcrossicon{
  right: 18px !important;
  font-size: 19px !important;
  top: 7px !important;
}

}
.storeFront{
  max-width: 1400px;
  margin: auto
}
.storeRightFilter {
  position: relative;
}
@import "../../node_modules/slick-carousel/slick/slick.css";
.storeRightFilter .searchInputField{
    border: 1px solid #ccc !important;
}

.number {
		/* padding: 5px 10px; */
		/* border: 1px solid var(--main-color); */
		display: inline-block;
	}
	.number > a {
		text-decoration: none;
		color: var(--font-dark-blue);
		font-size: 15px;
		position: relative;
		padding-left: 15px;
	}
	.number > a::before {
		content: "\f095";
		font-family: 'FontAwesome';
		position: absolute;
		left: -3px;
		top: -1px;
		color: var(--main-color);
		font-size: var(--font-size-heading);
	}
.miniStoreHeading {
  font-family: "lhmBold";
  color: var(--font-dark-blue);
}
.storeMenu {
  background-color: #f5f5f5;
}
.storeLogo {
  max-height: 80px;
}
.storeLandingNavLinks {
  padding: 0;
  margin: 0;
}
.storeLandingNavLinks li {
  list-style: none;
  float: left;
  padding: 3px;
  font-size: 14px;
  font-family: "lhmRegular";
  cursor: pointer;
  margin: 25px 20px;
  /* border-bottom: 2px solid #fff; */
}
.storeLandingNavLinks li a {
  color: var(--font-dark-blue);
}
.storeLandingNavLinks li a:hover{
  color: var(--main-color);
}
.storeLinkActive {
  border-bottom: 2px solid var(--main-color) !important;
}
.store-grid-2 h4 {
  font-size: 20px;
  margin-top: 5px;
}
.store-grid-2 {
  position: relative;
}
.grid-2-btn {
  position: absolute;
  bottom: 30px;
  left: 15px;
  border: 1px solid #000;
  color: #fff;
  padding: 10px 30px;
  background-color: #000;
  font-size: var(--font-size-regular);
  text-transform: uppercase;
}
.grid-2-btn:hover {
  color: #fff;
}
.centerButton {
  left: 50%;
  transform: translate(-50%);
}

.browserStore {
  margin-top: -5px;
  padding: 14px;
  text-align: center;
  background-image: url("/img/bg.png");
  background-repeat: no-repeat;
  background-size: cover;
}
.storeShop.row a.clo-md-3 {
  flex: 1;
}
.browserStore > a {
  color: var(--font-dark-blue);
  font-size: var(--font-size-heading);
  line-height: 20px;
  text-decoration: none;
  text-transform: uppercase;
  letter-spacing: 0.5em;
  font-family: lhmRegular;
}
.browserStore > a::after {
  content: "\f178";
  font-family: "fontello";
}
.storeTrending {
  padding: 35px 0px;
  margin: 0px !important;
}
.storeTrending img {
  width: 100%;
}
.storeHeading {
  padding: 15px 0px;
  text-align: center;
}
/* .storeTrending > .col-md-4:last-child {
			    padding-right: 0px !important;
			    
			}
			.storeTrending > .col-md-4:first-child{
			    padding-left: 0px !important;
			} */
.storeHeading h2 {
  font-size: 32px;
  line-height: 80px;
  color: #626262;
  font-family: lhmRegular;
  text-transform: uppercase;
}
.storeShop {
  display: flex;
  margin-bottom: 10px;
  width: 100%;
  justify-content: flex-start;
  align-content: flex-start;
}
.shopImage {
  position: relative;
  flex: 1;
  padding: 0px 5px;
}
.shopImage > img {
  width: 100%;
  max-height: 490px;
  overflow: hidden;
}
video {
  object-fit: cover;
}
.shopImage > span {
  position: absolute;
  /* top: 0px; */
  right: 0px;
  bottom: 30px;
  background: #ffffff;
  color: var(--main-color);
  padding: 0px 20px;
  font-size: var(--font-size-heading);
  line-height: 40px;
  font-family: "lhmregular";
}
.shopVideo {
  padding: 50px 100px;
  background: radial-gradient(
    50% 50% at 50% 50%,
    rgba(0, 0, 0, 0) 0%,
    rgba(0, 0, 0, 0.5) 100%
  );
  /* height: 854px; */
  background-size: contain;
}
.shopVideo {
  width: 100%;
  /* background: url('/img/nike.png') ;
			    background-size: contain; */
  position: relative;
}
.shopVideo h2 {
  text-align: center;
  color: #ffffff;
  font-size: 32px;
  line-height: 84px;
  font-family: "lhmRegular";
}
.shopVideo h1 {
  text-align: center;
  color: #626262;
  font-size: 88px;
  line-height: 120px;
  font-family: lhm;
  text-transform: uppercase;
}
.shopVideo h1 span {
  color: var(--main-color);
  font-family: "lhmSemiBold";
  text-transform: uppercase;
}
.shopVideo h3 {
  text-transform: uppercase;
  text-align: right;
  color: #626262;
}
.policyTab {
  display: flex !important;
  padding: 20px 10px;
  margin: 0px 2rem;
  font-size: 16px;
  line-height: 24px;
  color: #626262;
  display: block;
  cursor: pointer;
  border-bottom: 1px solid transparent;
  font-family: 'lhmRegular';
}
.policyTab.active {
  border-bottom: 1px solid var(--main-color);
}
.policyTab:hover{
  border-bottom: 1px solid var(--main-color);
}
.policyContent {
  font-size: 14px;
  line-height: 24px;
  padding: 2rem;
  text-align: left;
  color: var(--font-dark-blue);
  max-width: 1200px;
  margin: auto;
}
.policyContent h3{
  font-size: var(--font-size-heading);
  font-family: 'lhmBold';
}
.policyContent h2{
  font-size: var(--font-size-heading);
  font-family: 'lhmBold';
}
.policyContent h1{
  font-size: var(--font-size-heading);
  font-family: 'lhmBold';
  padding: 10px 0;
}
.policyContent pre{
  font-size: 14px;
  line-height: 24px; 
  text-align: left;
  color: var(--font-dark-blue);
  max-width: 1200px;
  margin: auto;
  font-family: 'lhmRegular';
}
.shopPlay {
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
}
.featuredProducts .slick-slider .slick-next {
  right: 60px;
  top: -30px;
}
.featuredProducts .slick-slider .slick-prev {
  top: -30px;
  left: 90%;
}
.policyTabs {
  display: flex;
  justify-content: center;
  align-items: center;
  font-family: "lhm";
  margin-bottom: 20px;
}
.policyTab {
  padding: 20px 10px;
  margin: 0px 2rem;
  font-size: 16px;
  line-height: 24px;
  color: #626262;
  display: block;
  cursor: pointer;
}
.policyTab.active {
  /* border-bottom: 1px solid var(--main-color); */
}
.policyContent {
  font-size: 14px;
  line-height: 24px;
  padding: 2rem;
  text-align: left;
  color: var(--font-dark-blue);
}
.storeSection{
  padding-left: 50px;
  padding-right: 50px;
}
@media screen and (max-width: 767px) {
 .input.activeSearch.newAtiveSearch {
    top: 0px;
  }
  .storeSection{
    padding-left: 10px;
    padding-right: 10px;
  }
	.grid-2-btn{
		font-size: 13px;
		padding: 6px 10px !important;
	}
  
  .storeMobileMenu {
    text-align: right;
    font-size: 16px;
    line-height: 50px;
    color: #000;
    width: 40px;
    margin-left: 15px;
  }
  .policyTab{
	  margin: 0px 1rem;
  }
  .policyTab a{
	  color: var(--font-dark-blue);
  }
  .storeLandingNavLinks {
    /* display: none; */
    position: absolute;
    top: 100%;
    width: 100%;
    z-index: 99;
    background-color: #fff;
    right: 3vw;
    box-shadow: 0 0 4px #ccc;
    padding: 5px;
  }
  .storeMobileMenu:hover .storeLandingNavLinks {
    display: block;
  }
  .storeLandingNavLinks li {
    width: 100%;
    text-align: left;
    display: inline-block;
    margin: 0;
    padding: 5px;
  }
  .storeMobileMenu .burger {
    font-size: 30px;
    float: right;
    margin: 0px 0;
    color: var(--font-dark-blue);
    padding-left: 10px;
    right: 10px;
    left: auto;
    top: 38%;
    transform: translateX(-50%);
  }
  .shopImage > span {
    left: 0;
    padding: 0px 25px;
    font-size: 16px;
    line-height: 40px;
    right: auto;
  }
  .storeTrending img {
    margin-bottom: 10px;
  }
  .featuredProducts .slick-slide {
    margin-left: 8px;
    margin-right: 8px;
  }
}
</style>
<script>
import slick from "vue-slick";
import axios from "axios";
import Banner from "./Store/Banner";
import OneByTwo from "./Store/OneByTwo";
import OneByThree from "./Store/OneByThree";
import ProductsGrid from "./Store/ProductsGrid";
import ProductsGridWithSlick from "./Store/ProductsGridWithSlick";
import Slider from "./Store/Slider";
import Video from "./Store/Video";
import SliderOneByThree from "./Store/sliderOneByThree";
import GoogleMap from "../GoogleMap";
// import search from './Services/Search'
import search from './Services/newsearch'
  var debouncetimer;
export default {
  components: {
    search,
    slick,
    Banner,
    OneByTwo,
    OneByThree,
    ProductsGrid,
    ProductsGridWithSlick,
    Slider,
    Video,
    SliderOneByThree,
    GoogleMap
  },
  computed:  {
    refinedMenu () {
      let menu = []
      if(this.menu.length > 3) {
        menu = this.menu.slice(Math.max(this.menu.length - 3, 0))

      } else {
        menu = this.menu
      }
      return menu
    }

  },
  data() {
    return {
      search:'',
      loader:true,
      categories : [],
      searchres:false,
      noresult:false,
      searchingres:false,
      searchresult:false,
      searchloader:false,
      searchclose:false,
      removesearchicon:false,
      errorMsg: '',
      errorToast: false,
      isStoreLocation: false,
      storeSearchToggle: false,
      isMenu : false,
      storeName: '',
      isStoreSearch : false,
      popUpStores: [],
      storeTemplate: [{
        sections: []
      }],
      id: null,
      policies: [{phone_number: null,whatsapp_number: null
      }],
      content: "",
      menu: [],
      inner_menu: [],
      slides: [],
      logo: "",
      themeId:1,
      store_address : [],
      storeLocation: "",
      center: {
					lat: parseInt(this.$root.location.lat),
					lng: parseInt(this.$root.location.long),
				},
				markers: [
					{
						position: {
							lat: parseInt(this.$root.location.lat),
							lng: parseInt(this.$root.location.long),
						},
					},
				],
      store_closed: false,


    };
  },
  created() {
    this.getStoreTemplate();
    
  },
  methods: { 
    enterFirstLink : function (){
				let searchval=	document.getElementById("searchval").value
				this.search=searchval
				// let firtLink = document.querySelector('.categoryLink').getAttribute("href");
				this.$router.push({ path:'/category/all.html' , query: { sq: this.search},});
				document.getElementById("searchval").value=''
				this.search=''
        this.searchloader=false
        this.searchclose=false
        this.removesearchicon=false
        this.searchres=false;
        this.noresult=false
        this.searchingres=false
        this.searchresult=false
				this.$root.isStore = false
				this.$root.searchCount += 1
		},
    closeStoreSearch(){
      this.isStoreSearch = false
      document.getElementById("searchval").value=''
      this.search=''
      this.searchloader=false
      this.searchclose=false
      this.removesearchicon=false
      this.searchres=false;
      this.noresult=false
      this.searchingres=false
      this.searchresult=false
    },
    closeSearch(){
      document.getElementById("searchval").value=''
      this.search=''
      this.searchloader=false
      this.searchclose=false
      this.removesearchicon=false
       this.searchres=false;
       this.noresult=false
       this.searchingres=false
       this.searchresult=false
    },
      debouncesearch(){
        var searchvalue=document.getElementById("searchval").value
         this.search=searchvalue
        if(searchvalue.trim().length==0){
          this.searchloader=false
          this.searchclose=false
          this.removesearchicon=false
          this.searchres=false
          this.searchingres=false
          this.noresult=false
          this.searchresult=false
          this.products = []
          this.categories = [];
        }
        else if(searchvalue.trim().length<=2){
          this.search=''
          this.searchloader=false
          this.searchclose=false
          this.removesearchicon=false
          this.searchres=false
          this.searchingres=false
          this.noresult=false
          this.searchresult=false
          this.products = []
          this.categories = [];
        }
        else{
          this.noresult=false
          this.searchresult=false
          this.searchres=true
          this.searchingres=true
          this.removesearchicon=true
          this.searchloader=true
          this.searchclose=true
          clearTimeout(debouncetimer);
				  debouncetimer= setTimeout(() => {
					this.getStoresSearch()
					}, 1000);
        
        }
			},

      getStoresSearch() {
        let searchvalue=document.getElementById("searchval").value.replace(/\s+/g, ' ').trim();
        this.search=searchvalue
					axios
						.get(
							`${this.$root.api_url}/pim/pimresponse.php?service=search&store=${this.$route.query.store}&sq=${searchvalue}`
						)
						.then((res) => { 
						this.searchloader=false
            this.searchingres=false
            this.categories=res.data.result
            console.log("categories",this.categories)
            console.log(this.categories.length)
            if(this.categories.length==0){
             this.noresult=true
             this.searchresult=false
            }
            else{
                this.noresult=false
                this.searchresult=true
            }

						})
						.catch((err) => {
							console.log(err);
						});
				
			},
         
      storeFrontLocation() {
        // console.log('popup hits'); 
        this.isStoreLocation = true;
      }, 
      loaderTimeOut(){
        setTimeout(()=> {
        this.loader = false
     
      },500)
},
    
    storeSearchIcon(){
      // alert('asda');
      this.storeSearchToggle = !this.storeSearchToggle
    },
    changeCenter(){
     
      this.markers[0].position.lat =parseFloat(this.store_address.location_latitude)  ;  
      
							
							this.markers[0].position.lng = parseFloat(this.store_address.location_longitude);
							
							this.center = {
								lat:parseFloat(this.store_address.location_latitude),
								lng: parseFloat(this.store_address.location_longitude),
							};
    },

    toggleMenu() {
      
      this.isMenu = !this.isMenu;
    },

    policyContent(id) {
      if(id!=null){
        this.content = this.policies[id].content;
        this.store_address = '';
        if (this.policies[id].name == "Contact Us") {
            this.store_address = this.policies[id].store_details[0];
//  console.log(this.store_address);
            this.changeCenter()
        }

      }
      this.id = id;
      
      // console.log(this.policies[id].content);
    },

    // ${this.$route.query.store
    getStoreTemplate() {

      this.loader = true;
      axios
        .get(
          this.$root.api_url +
            `/pim/store-front.php?store_id=${this.$route.query.store}&latitude=${this.$root.location.lat}&longitude=${this.$root.location.long}`
        )
        .then((response) => {
          if (response.data.response.error === 1){
            // alert('store is closed')
              this.errorToast = response.data.result.toast;
              this.errorMsg = response.data.response.error_message;
              if(this.errorToast == true){
                this.$toast.warning(response.data.result.message, {
                  position: "top",
                  duration: 10000,
                });
              }
              
          }else{
          // console.log(response.data);
          if (response.data.result) {
            if(response.data.result.show_toast_message==true){
            this.$toast.warning(response.data.result.toast_message, {
                position: "top",
                duration: 8000,
              });
            }
            this.storeTemplate = response.data.result.sections;
            this.policies = response.data.result.policies;
            this.slides = response.data.result.slider.sliders;
            this.menu = response.data.result.outer_menu;
            this.inner_menu = response.data.result.inner_menu ;
            this.themeId = response.data.result.theme_id;
            this.logo = response.data.result.store_logo[0].store_logo;
            this.storeLocation = response.data.result.store_location;
            this.popUpStores = response.data.result.similar_stores ? response.data.result.similar_stores : [];
            //console.log("this.popUpStores",this.popUpStores);
            this.storeName = response.data.result.brandName;
          // this.loaderTimeOut()
          } else {
            this.store_closed = true;
          }
          }
        })
        .catch((error) => {
          if (error.message === "Network Error") {
            this.$root.error_message =
              "Oops there seems to be some Network issue, please try again.";
          }
        }).finally(()=> {

          this.loaderTimeOut()
         
        });
     
    },
  },  
  beforeMount(){
		document.addEventListener("keyup", evt => {
			if (evt.keyCode == 27) {
				// alert('adsfa');
				this.isMenu = false;
        this.isStoreSearch = false;
        this.isStoreLocation = false;
			}
		});
	},
};
</script>

<style scoped>
.search-text{
  text-transform: capitalize;
}
.matchcategory{
  font-size: 15px !important;
  text-transform: uppercase;
  color: #ba2126;
  padding-bottom: 9px;
  font-family: lhmBold;
}
/* simmer style */
.shimmerContainer .Skeletonitem1{
  height: 410px;
  display:block; 
  margin-bottom:10px 
}
.shimmerContainer .Skeletonitem2{
  height: 80px;
  display:block;
  margin-bottom: 8px; 
}
.shimmerContainer .Skeletonitem3{
  display: block;
  height: 60px;

}
.shimmerContainer .Skeletonitem4{
  display:none;
}
  @media screen and (max-width: 767px) {
  
  .shimmerContainer .Skeletonitem1{
  height: 120px;
  display:block; 
  margin-bottom:5px 
}
.shimmerContainer .Skeletonitem2{
  height: 100px;
  display:block; 
  margin-bottom: 10px;
}
.shimmerContainer .Skeletonitem3{
  display: block;
  height:350px;
  margin-bottom: 10px;

}
.shimmerContainer .Skeletonitem4{
  display: block;
  height:350px;
  margin-bottom: 10px;

  }
  }
  @media screen and (max-width: 380px) {
  
  .shimmerContainer .Skeletonitem1{
  height: 100px;
  display:block; 
  margin-bottom:5px 
}
.shimmerContainer .Skeletonitem2{
  height: 80px;
  display:block; 
  margin-bottom: 10px;
}
.shimmerContainer .Skeletonitem3{
  display: block;
  height:300px;
  margin-bottom: 10px;

}
.shimmerContainer .Skeletonitem4{
  display: block;
  height:300px;
  margin-bottom: 10px;

  }
  }
</style>